import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import WhiteBox from '@lib/components/WhiteBox/WhiteBox';
import Form, { FormRef } from '@lib/components/ReactHookForm/FormContainer';
import FieldNames from '@lib/enums/fieldNames/importHistoryFilterFieldNames';
import { IMPORT_FILTER_FORM } from '@lib/enums/localStorageKeys';
import usePaginationParams from '@lib/hooks/usePaginationParams';
import { GetUrlParams, PAGINATION_PARAMS } from '@lib/enums/urls';
import useFilterFields from './useFilterFields';
import styles from './ImportHistoryFilter.module.scss';
import { IMPORT_FILTER_EMPTY_VALUES } from '../../constants';

export default function ImportHistoryFilter({
  isSitesAvailable,
  isAssetsAvailable,
}: {
  isSitesAvailable: boolean;
  isAssetsAvailable: boolean;
}) {
  const { t } = useTranslation();
  const formRef = useRef<FormRef>(undefined);
  const [paginationParams, setPaginationParams] = usePaginationParams();

  const resetPaginationParams = () => {
    setPaginationParams({
      ...(paginationParams || PAGINATION_PARAMS),
      [GetUrlParams.Page]: '1',
    });
  };

  const clearFilter = () => {
    formRef.current?.setValue(FieldNames.Type, []);
    resetPaginationParams();
  };

  const fields = useFilterFields({
    clearFilter,
    isAssetsAvailable,
    isSitesAvailable,
    t,
  });

  return (
    <WhiteBox
      verticalPaddings="extraSmall"
      horizontalPaddings="small"
      className={styles.filter}
    >
      <Form
        defaultValues={IMPORT_FILTER_EMPTY_VALUES}
        disableAwayConfirmation
        fields={fields}
        formId={IMPORT_FILTER_FORM}
        formItemsClassName={styles.filterRow}
        formRef={formRef}
        persistForm
        submitOnChange
        onSubmit={resetPaginationParams}
      />
    </WhiteBox>
  );
}
